import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
import axios from 'axios';
import { API_BASE_URL } from 'config';

// reducer
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// ui
import Loader from 'ui-component/Loader';

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

const JWTContext = createContext(null);

// ==============================|| JWT PROVIDER ||============================== //

export function JWTProvider({ children }) {
  const [state, dispatch] = useReducer(accountReducer, initialState);

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      setSession(token);
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          user: null
        }
      });
    }

    dispatch({ type: 'INITIALIZE' });
  }, []);

  const setSession = (token) => {
    if (token) {
      localStorage.setItem('token', token);
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      localStorage.removeItem('token');
      delete axios.defaults.headers.common.Authorization;
    }
  };

  const login = async (email, password) => {
    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    

    if (!response.ok) {
      throw new Error('Invalid credentials');
    }

    const data = await response.json();

    // SAVE TOKEN
    localStorage.setItem('token', data.token);

    setSession(data.token);

    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        user: { email }
      }
    });
  };

  const logout = () => {
    dispatch({ type: LOGOUT });
  };

  const register = async () => {};
  const resetPassword = async () => {};
  const updateProfile = async () => {};

  if (!state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        register,
        resetPassword,
        updateProfile
      }}
    >
      {children}
    </JWTContext.Provider>
  );
}

JWTProvider.propTypes = {
  children: PropTypes.node
};

export default JWTContext;
